/**
* 【文档：】
* https://developer.openinstall.io/p-1551514626/web.html#javascript
* 【说明：】
* 使用openinstall打开或者下载app
* 链接必须带有channelCode,因为读取的是链接带的参数，而不是代码data里面传的参数
* 现在方式是按照文档尽早openinstall初始化,如果需要传"其他数据(除channelCode)",则需要获取了其他数据后再初始化，并把数据放到data里面
* 【使用方法：】
* 0.页面引入<script type="text/javascript" charset="UTF-8" src="//res.cdn.openinstall.io/openinstall.js"></script>
* 1.引入此mixin，import openinstallMixin from '@/mixin/openinstallMixin'; // 引入mixin文件
* 2.初始化，在mouted的时候调用initOpenInstall，如果需要传其他数据，则获取数据赋值给openInstallData，再初始化
* 3.点击的时候调用：this.openInstallObj.wakeupOrInstall()
* 可传字段：activityCode: "5",
          activityUuid: "8046969e35d111eabe7f6c92bf62e6ee",
          senderUuid: res.uuid,
          senderDeviceId: "",
          activityExtend: "",
          uploadTime: time
*/
export default {
  data() {
    return {
      openInstallObj:'',
      openInstallData:{}
    }
  },
  mounted() {
    // this.initOpenInstall();
  },
  methods: {
    initOpenInstall(isSchemeWakeup=false, callback) {
      var self = this
      //openinstall初始化时将与openinstall服务器交互，应尽可能早的调用
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // console.log('data>>>',data)
      // var time = self.dateToyyyymmdd(new Date(), "YYYY-MM-dd hh:mm:ss");
      // data = {
      //   uploadTime: time
      // }
      if(JSON.stringify(self.openInstallData) != '{}'){
        data = self.openInstallData
      }
      // console.log('data>>>',data)

      new OpenInstall({
        /*appKey必选参数，openinstall平台为每个应用分配的ID*/
        appKey: "pnqcci",
        /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
        //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
        /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
        //preferWakeup:true,
        /*自定义遮罩的html*/
        //mask:function(){
        //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
        //},
        /*openinstall初始化完成的回调函数，可选*/
        onready: function() {
          var m = this;
            // button = document.getElementById("downloadButton");
            // button.style.visibility = "visible";

          self.openInstallObj = this
          /*在app已安装的情况尝试拉起app*/
		  if(isSchemeWakeup){
			  m.schemeWakeup();
		  }
		  
		  callback&&callback()
          /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
          // button.onclick = function() {
          //   m.wakeupOrInstall();
          //   return false;
          // }
        }
      }, data);
    }
  }
}
